import axios from 'axios'
import environment from '@environment'
import HttpErrorResponseModel from '@models/http-error-response-model'

const apiURL = environment.managerApi.baseURL

const api = axios.create({
  baseURL: apiURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.response.use(
  response => {
    return response
  },
  err => {
    if (!err) return new HttpErrorResponseModel(0, null)
    if (!err?.response?.data) new HttpErrorResponseModel(0, null)
    return new HttpErrorResponseModel(err.response.data.status, err.response.data.message)
  }
)

export default api
